/**
 * SEO 配置 - models (Italiano)
 */

export default {
    veo_3_1: {
        title: 'Google Veo 3.1 - Generatore video IA di punta | WeryAI',
        description: 'Google Veo 3.1: Modello video IA di punta con audio nativo e controllo frame.',
        keywords: 'Google Veo 3.1, video IA, generatore video, WeryAI',
    },
    veo_3: {
        title: 'Google Veo 3 - Generazione video IA di alta qualità | WeryAI',
        description: 'Prova Veo 3 su WeryAI. Risultati di alta qualità.',
        keywords: 'Veo 3, Google Veo, video IA, WeryAI',
    },
    veo_3_fast: {
        title: 'Google Veo 3 Fast - Generazione video IA ultraveloce | WeryAI',
        description: 'Prova Veo 3 Fast su WeryAI. Risultati veloci e di alta qualità.',
        keywords: 'Veo 3 Fast, video IA veloce, WeryAI',
    },
    sora_2: {
        title: 'OpenAI Sora 2 - Generatore video IA realistico | WeryAI',
        description: 'Prova Sora 2 su WeryAI. Risultati di alta qualità.',
        keywords: 'Sora 2, OpenAI Sora, video IA, WeryAI',
    },
    weryai_video_1: {
        title: 'WeryAI Video 1.0 - Generatore video IA | WeryAI',
        description: 'Prova WeryAI Video 1.0 per creare video IA cinematografici.',
        keywords: 'WeryAI Video 1.0, video IA, WeryAI',
    },
    weryai_image_2: {
        title: 'WeryAI Image 2.0 - Generatore immagini IA | WeryAI',
        description: 'Prova WeryAI Image 2.0 per generare immagini di qualità studio.',
        keywords: 'WeryAI Image 2.0, immagini IA, WeryAI',
    },
    image_grok_2: {
        title: 'Grok-2 Generatore Immagini - xAI | WeryAI',
        description: 'Prova Grok-2 di xAI su WeryAI.',
        keywords: 'Grok-2, xAI, immagini IA, WeryAI',
    },
    kling_ai: {
        title: 'Kling AI - Generatore video IA cinematografico | WeryAI',
        description: 'Prova Kling AI su WeryAI. Risultati di alta qualità.',
        keywords: 'Kling AI, video IA, WeryAI',
    },
    runway_ai: {
        title: 'Runway AI - Generatore e editor video IA | WeryAI',
        description: 'Prova Runway AI su WeryAI. Risultati di alta qualità.',
        keywords: 'Runway AI, video IA, WeryAI',
    },
    hailuo_23: {
        title: 'Hailuo 2.3 - Generatore video IA | WeryAI',
        description: 'Prova Hailuo 2.3 su WeryAI. Risultati di alta qualità.',
        keywords: 'Hailuo 2.3, video IA, WeryAI',
    },
    hailuo_ai: {
        title: 'Hailuo AI - Generatore video IA avanzato | WeryAI',
        description: 'Prova Hailuo AI su WeryAI. Risultati di alta qualità.',
        keywords: 'Hailuo AI, video IA, WeryAI',
    },
    pika_2_2: {
        title: 'Pika 2.2 - Generatore animazione IA | WeryAI',
        description: 'Prova Pika 2.2 su WeryAI. Risultati di alta qualità.',
        keywords: 'Pika 2.2, animazione IA, WeryAI',
    },
    seedance: {
        title: 'Seedance - Generatore video danza e movimento IA | WeryAI',
        description: 'Prova Seedance su WeryAI. Risultati realistici e professionali.',
        keywords: 'Seedance, video IA, WeryAI',
    },
    wan_ai: '',
    image_nano_banana_pro: {
        title: 'Nano Banana Pro - Generazione immagini Google Gemini 3.0 Pro | WeryAI',
        description: 'Modello immagini IA basato sul ragionamento. Qualità 4K ultra-realistica e tipografia perfetta.',
        keywords: 'Nano Banana Pro, Gemini 3.0 Pro, generazione immagini IA, WeryAI',
    },
    image_nano_banana: {
        title: 'Google Nano Banana - Disegno ultraveloce Gemini 2.5 Flash | WeryAI',
        description: 'Generatore immagini IA ultraveloce di Google DeepMind. Supporta editing in linguaggio naturale.',
        keywords: 'Nano Banana, Gemini 2.5 Flash, disegno veloce, WeryAI',
    },
    image_flux: {
        title: 'FLUX AI Generatore Immagini - Modello open source | WeryAI',
        description: 'FLUX sviluppato dal team di Stable Diffusion. Qualità visiva eccezionale.',
        keywords: 'FLUX, IA, generazione immagini, WeryAI',
    },
    image_flux_kontext: {
        title: 'FLUX.1 Kontext - Miglioramento professionale disegno IA | WeryAI',
        description: 'FLUX.1 Pro e Max con rendering testo migliorato e coerenza dei personaggi.',
        keywords: 'FLUX Kontext, FLUX Pro, FLUX Max, WeryAI',
    },
    image_imagen: {
        title: 'Google Imagen 4 - Modello diffusione testo-a-immagine | WeryAI',
        description: 'Crea immagini fotorealistiche, artistiche e astratte con Google Imagen 4.',
        keywords: 'Imagen 4, Google AI, diffusione, WeryAI',
    },
    image_qwen_image: {
        title: 'Qwen Image - Modello rendering testo Alibaba | WeryAI',
        description: 'Modello immagini IA di Alibaba per rendering testo multilingue.',
        keywords: 'Qwen Image, Alibaba, rendering testo, WeryAI',
    },
    image_wan_ai: {
        title: 'Wan 2.5 Generazione immagini - Modello alta fedeltà Alibaba | WeryAI',
        description: 'Wan 2.5 con tracciamento preciso dei prompt e rendering fotografico.',
        keywords: 'Wan AI, Wan 2.5, generazione immagini, WeryAI',
    },
    image_seendream: {
        title: 'Seedream 4.0 - Modello disegno batch 4K ByteDance | WeryAI',
        description: 'Modello disegno ultraveloce di ByteDance con elaborazione batch.',
        keywords: 'Seedream, ByteDance, disegno 4K, WeryAI',
    },
    image_dreamina: {
        title: 'Dreamina 4.0 - Modello creazione immagini IA ByteDance | WeryAI',
        description: 'Dreamina 4.0 per conversione schizzo in immagine e trasferimento stile.',
        keywords: 'Dreamina 4.0, ByteDance, creazione immagini IA, WeryAI',
    },
    image_seedream_4_5: {
        title: 'Seedream 4.5 - Modello di Generazione Immagini IA di Punta di ByteDance | WeryAI',
        description: 'Seedream 4.5 è il più recente modello di immagini IA di punta di ByteDance, focalizzato su rendering tipografico preciso e fusione multi-immagine con output 4K ultra HD. Provalo gratis su WeryAI.',
        keywords: 'Seedream 4.5, generazione immagini IA, rendering tipografico, fusione immagini, ByteDance, qualità 4K, WeryAI',
    },
    image_midjourney: {
        title: 'Midjourney - Generazione di immagini flessibile, dettagliata e vivace | WeryAI',
        description: 'Midjourney è un modello di immagini IA di punta di un laboratorio di ricerca indipendente, rinomato per la sua estetica artistica. Provalo gratis su WeryAI.',
        keywords: 'Midjourney, generazione immagini IA, creazione artistica, qualità illuminazione, rendering testo, ritratti iperrealistici, WeryAI',
    },
    runway_4_5: {
        title: 'Runway Gen-4.5 Generatore Video IA - Crea Video Cinematografici | WeryAI',
        description: 'Crea video straordinari con Runway Gen-4.5 su WeryAI. Architettura ibrida autoregressiva-diffusione per simulazione fisica precisa e coerenza temporale.',
        keywords: 'Runway Gen-4.5, generatore video IA, video IA cinematografico, simulazione fisica, Runway AI, WeryAI',
    },
    kling_2_6_pro: {
        title: 'Kling 2.6 Pro Generatore Video IA - Creazione Video di Alta Qualità | WeryAI',
        description: 'Genera video di alta qualità con Kling 2.6 Pro su WeryAI. Generazione audiovisiva nativa, qualità cinematografica 1080p, eccellente aderenza ai prompt.',
        keywords: 'Kling 2.6 Pro, generatore video IA, video IA di alta qualità, Kling AI, WeryAI',
    },
    video_dreamina_3: {
        title: 'Dreamina 3.0 Generatore Video - Controllo camera preciso e guida frame | WeryAI',
        description: 'Genera video IA cinematografici con Dreamina 3.0 (Jimeng 3.0) su WeryAI. Controllo preciso frame inizio/fine, movimenti camera professionali e generazione video 1080p ad alta dinamica.',
        keywords: 'Dreamina 3.0, Jimeng Video 3.0, generatore video IA, controllo camera, frame inizio fine, ByteDance AI, WeryAI',
    },
    kling_o1: {
        title: 'Kling O1 Generatore Video IA - Generazione Video Creativa | WeryAI',
        description: 'Libera la tua creatività su WeryAI con il generatore video IA Kling O1. Perfetto per generare contenuti video fantasiosi e unici.',
        keywords: 'Kling O1, generatore video IA, video IA creativo, Kling AI, WeryAI',
    },
}
